/**
 *
 * @module accountEntitlementContext
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef AccountEntitlementContext
 * @type {Object}
 * @desc Defines the accountEntitlementContext types
 *
 * @property {String} accountActiveEntitlement
 * @property {String} accountExpiredEntitlement
 * @property {String} accountNeverEntitled
 * @property {String} anonymous
 *
 */

/**
 *
 * @enum
 * @type {AccountEntitlementContext}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    accountActiveEntitlement: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    accountExpiredEntitlement: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    accountNeverEntitled: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    anonymous: null
});



// WEBPACK FOOTER //
// ./src/services/paywall/accountEntitlementContext.js